import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.Toolbar.EditWorkflowName', {
    label: 'Workflow name',
    placeholder: 'Enter a name for the approval workflow',
    edit: 'Edit',
    save: 'Save',
});
